import { Injectable, inject } from '@angular/core';
import { filter, Observable, Subject, takeUntil, tap } from 'rxjs';
import { HttpRequest } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from '@modules/shared/store';
import { SetSmsCode } from '@modules/confirmation/store/confirmation.action';
import { NeedCodeRequest } from '../models';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService {
  private store = inject<Store<AppState>>(Store);

  private readonly destroy$ = new Subject<void>();

  public confirmSms(data: HttpRequest<NeedCodeRequest>): Observable<string> {
    return this.store
      .select(state => state.confirmation.smsCode)
      .pipe(
        filter(code => !!code),
        tap(code => {
          data.body.confirmationData = code;
          this.store.dispatch(new SetSmsCode(null));
        }),
        takeUntil(this.destroy$)
      );
  }

  public unsubscribeSmsCode(): void {
    this.destroy$.next();
  }
}
